var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
export default function ImageWidget() {
    var widget = {
        id: "",
        type: "",
        payload: {
            url: "https://source.unsplash.com/300x200/?inspire",
        },
    };
    return (_jsx("div", __assign({ className: "widget-content" }, { children: _jsx("figure", { children: _jsxs("div", __assign({ className: "image-container relative w-[".concat(widget.payload.width, "] h-[").concat(widget.payload.height, "]") }, { children: [_jsx("img", { src: "".concat(widget.payload.url), alt: "".concat(widget.payload.alt) }), _jsx("div", __assign({ className: "image-overlay flex absolute justify-end items-end top-0 left-0 w-full h-full bg-transparent pointer-events-none" }, { children: _jsx("div", __assign({ className: "overlay-content text-base p-1 opacity-[0.5]" }, { children: widget.payload.overlay })) }))] })) }) })));
}
widgetsDictionary.register("dev/image/test", {
    name: "Image",
    display: ImageWidget,
});
